import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect = () => {
    const dateControllers = document.querySelectorAll('[data-controller*="date-format"]')
    if (!dateControllers.length) return
    this.render(dateControllers)
  }

  dateFormat = (format) => {
    const formats = ['date', 'datetime']
    if (formats.some(f => f === format)) {
      return format
    }
    return 'datetime'
  }

  dateFormatOptions = (format) => {
    if (format === 'date') {
      return {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }
    }

    return {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    }
  }

  render = (controllers) => {
    controllers.forEach((controller) => {
      controller.querySelectorAll('[data-date-format]').forEach((element) => {
        const dateString = element.innerHTML
        const date = new Date(dateString)
        const format = this.dateFormat(element.dataset.dateFormat)
        const options = this.dateFormatOptions(format)
        const formattedDate = date.toLocaleDateString('en-us', options)
        const dateFormatWithTimezone = `${formattedDate} ${this.timezone}`
        element.innerHTML = dateFormatWithTimezone
        element.setAttribute('title', dateString)
      })
    })
  }

  get timezone() {
    const dateWithTimezone = new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' })
    const timezone = dateWithTimezone.split(' ')[2]
    return timezone
  }
}
